import { render } from "./CurrentAddress.vue?vue&type=template&id=19d8c9c6"
import script from "./CurrentAddress.vue?vue&type=script&lang=js"
export * from "./CurrentAddress.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__